import React from 'react';
import './SchoolCard.css';

const SchoolCard = ({
  schoolName,
  tagline,
  description,
  features = [],
  buttonText = 'Learn More',
  buttonLink = '#',
  studentImage,
  schoolBgImage,
}) => {
  return (
    <div className="school-card">
      <div className="school-card-left">
        <h2 className="school-card-title">{schoolName}</h2>
        <h3 className="school-card-tagline">{tagline}</h3>
        <p className="school-card-description">{description}</p>
        <ul className="school-card-features">
          {features.map((feature, idx) => (
            <li key={idx}>{feature}</li>
          ))}
        </ul>
        {buttonText && <button className="school-card-btn" onClick={() => window.location.href = buttonLink}>{buttonText}</button>}
      </div>
      
      <div className="school-card-right">
        <div className="school-card-bg-wrap">
          {schoolBgImage && (
            <img src={schoolBgImage} alt="School background" className="school-card-bg" />
          )}
          {studentImage && (
            <img src={studentImage} alt="Student" className="school-card-student" />
          )}
        </div>
      </div>
    </div>
  );
};

export default SchoolCard; 